import vailresortsPic from '../images/clientLogos/vailresorts.png';
import timfokPic from '../images/clientLogos/timfok.png';
import epicpassPic from '../images/clientLogos/epicpass.png';
import wbPic from '../images/clientLogos/wb2.png';
import vailPic from '../images/clientLogos/vail.png';
import bcPic from '../images/clientLogos/beavercreek.png';
import breckPic from '../images/clientLogos/breck.png';
import cbPic from '../images/clientLogos/crestedbutte.png';
import heavenlyPic from '../images/clientLogos/heavenly.png';
import hunterPic from '../images/clientLogos/hunter.png';
import keystonePic from '../images/clientLogos/keystone.png';
import kirkwoodPic from '../images/clientLogos/kirkwood.png';
import mtsnowPic from '../images/clientLogos/mountsnow.png';
import northstarPic from '../images/clientLogos/northstar.png';
import okemoPic from '../images/clientLogos/okemo.png';
import pcPic from '../images/clientLogos/parkcity.png';
import spPic from '../images/clientLogos/stevenspass.png';
import stowePic from '../images/clientLogos/stowe.png';
import psiaPic from '../images/clientLogos/psia.png';
import pnsaaPic from '../images/clientLogos/pnsaa.png';
import snowopPic from '../images/clientLogos/snowop.png';
import sierraPic from '../images/clientLogos/sierra3.png';

export const clients = {

    timFok: {
        id: '001',
        name: 'Tim Fok - Director of Photography',
        logo: timfokPic,
        logoType: "client-logo-square",
        link: "https://www.timfok.com/"
    },

    vailResorts: {
        id: '002',
        name: 'Vail Resorts',
        logo: vailresortsPic,        
        logoType: "client-logo-long",
        link: "http://www.vailresorts.com/"
    },

    epicPass: {
        id: '003',
        name: 'Epic Pass',
        logo: epicpassPic,        
        logoType: "client-logo-long",
        link: "http://www.epicpass.com/"
    },

    wb: {
        id: '004',
        name: 'Whistler Blackcomb',
        logo: wbPic,        
        logoType: "client-logo-long",
        link: "http://www.whistlerblackcomb.com/"
    },

    vail: {
        id: '005',
        name: 'Vail',
        logo: vailPic,        
        logoType: "client-logo-long",
        link: "http://www.vail.com/"
    },

    breck: {
        id: '006',
        name: 'Breckenridge Resort',
        logo: breckPic,        
        logoType: "client-logo-square",
        link: "http://www.breckenridge.com/"
    },

    beaverCreek: {
        id: '007',
        name: 'Beaver Creek',
        logo: bcPic,        
        logoType: "client-logo-square",
        link: "http://www.beavercreek.com/"
    },

    crestedButte: {
        id: '008',
        name: 'Crested Butte',
        logo: cbPic,        
        logoType: "client-logo-long",
        link: "http://www.skicb.com/"
    },

    heavenly: {
        id: '009',
        name: 'Heavenly',
        logo: heavenlyPic,        
        logoType: "client-logo-long",
        link: "http://www.skiheavenly.com/"
    },

    keystone: {
        id: '010',
        name: 'Keystone',
        logo: keystonePic,        
        logoType: "client-logo-square",
        link: "http://www.keystoneresort.com/"
    },

    hunter: {
        id: '011',
        name: 'Hunter Mountain',
        logo: hunterPic,        
        logoType: "client-logo-square",
        link: "http://www.huntermtn.com/"
    },

    kirkwood: {
        id: '012',
        name: 'Kirkwood',
        logo: kirkwoodPic,        
        logoType: "client-logo-long",
        link: "http://www.kirkwood.com/"
    },

    mountSnow: {
        id: '013',
        name: 'Mount Snow',
        logo: mtsnowPic,        
        logoType: "client-logo-square",
        link: "http://www.mountsnow.com/"
    },

    northstar: {
        id: '014',
        name: 'Northstar',
        logo: northstarPic,        
        logoType: "client-logo-long",
        link: "http://www.northstarcalifornia.com/"
    },

    okemo: {
        id: '015',
        name: 'Okemo',
        logo: okemoPic,        
        logoType: "client-logo-long",
        link: "http://www.okemo.com/"
    },

    parkCity: {
        id: '016',
        name: 'Park City Mountain',
        logo: pcPic,        
        logoType: "client-logo-long",
        link: "http://www.parkcitymountain.com/"
    },

    stevensPass: {
        id: '017',
        name: 'Stevens Pass',
        logo: spPic,        
        logoType: "client-logo-square",
        link: "http://www.stevenspass.com/"
    },

    stowe: {
        id: '018',
        name: 'Stowe',
        logo: stowePic,        
        logoType: "client-logo-square",
        link: "http://www.stowe.com/"
    },

    psia: {
        id: '019',
        name: 'Professional Ski Instructors of America',
        logo: psiaPic,        
        logoType: "client-logo-square",
        link: "http://www.thesnowpros.org/"
    },

    pnsaa: {
        id: '020',
        name: 'Pacific Northwest Ski Areas Association',
        logo: pnsaaPic,        
        logoType: "client-logo-square",
        link: "http://www.pnsaa.org"
    },

    snowOperating: {
        id: '021',
        name: 'Snow Operating',
        logo: snowopPic,        
        logoType: "client-logo-long",
        link: "http://www.snowoperating.com/"
    },

    sierraAtTahoe: {
        id: '022',
        name: 'Sierra-at-Tahoe Resort',
        logo: sierraPic,        
        logoType: "client-logo-square",
        link: "http://www.sierraattahoe.com/"
    },
};